import React from "react";
import { InfoRow, Tooltip } from "@KristianIV/common-ui";
import { HOST_METRIC_EXPLANATIONS } from "../hostWarnings";
import { HostStatus } from "../model/scout";

const isNumber = (value: number | null | undefined): value is number => typeof value === "number";

const Explained = ({ text, children }: { text: string; children: React.ReactNode }) => (
  <Tooltip content={text}>
    <span>{children}</span>
  </Tooltip>
);

/**
 * Host health rows for the Device card of a JVM scout: temperature and the Verbose-level numbers when sent.
 * The device's warnings sit beside the name in the page header. Rendered inside the card's InfoGroup.
 */
const HostRows = ({ host }: { host: HostStatus }) => (
  <>
    {isNumber(host.temperature) && (
      <InfoRow label="Temperature">
        <Explained text={HOST_METRIC_EXPLANATIONS.temperature}>{host.temperature.toFixed(1)} °C</Explained>
      </InfoRow>
    )}
    {isNumber(host.memAvailableMb) && (
      <InfoRow label="Memory available">
        <Explained text={HOST_METRIC_EXPLANATIONS.memAvailableMb}>{host.memAvailableMb} MB</Explained>
      </InfoRow>
    )}
    {isNumber(host.rssMb) && (
      <InfoRow label="Scout process">
        <Explained text={HOST_METRIC_EXPLANATIONS.rssMb}>{host.rssMb} MB</Explained>
      </InfoRow>
    )}
    {isNumber(host.gcPausePercent) && (
      <InfoRow label="GC pause">
        <Explained text={HOST_METRIC_EXPLANATIONS.gcPausePercent}>{host.gcPausePercent.toFixed(1)} %</Explained>
      </InfoRow>
    )}
    {isNumber(host.load) && (
      <InfoRow label="Load">
        <Explained text={HOST_METRIC_EXPLANATIONS.load}>
          {host.load.toFixed(2)}
          {isNumber(host.cores) ? ` on ${host.cores} cores` : ""}
        </Explained>
      </InfoRow>
    )}
  </>
);

export default HostRows;
